type StatusVariant = 'session' | 'handover' | 'default';

interface StatusBadgeProps {
  status: string;
  variant?: StatusVariant;
  className?: string;
}

const sessionColors: Record<string, string> = {
  active: 'bg-green-100 text-green-800',
  online: 'bg-green-100 text-green-800',
  idle: 'bg-yellow-100 text-yellow-800',
  ended: 'bg-surface-100 text-surface-800',
  handed_over: 'bg-blue-100 text-blue-800',
  handover_requested: 'bg-orange-100 text-orange-800',
  agent_active: 'bg-purple-100 text-purple-800',
};

const handoverColors: Record<string, string> = {
  pending: 'bg-orange-100 text-orange-800',
  waiting: 'bg-yellow-100 text-yellow-800',
  assigned: 'bg-blue-100 text-blue-800',
  in_progress: 'bg-purple-100 text-purple-800',
  resolved: 'bg-green-100 text-green-800',
  cancelled: 'bg-surface-100 text-surface-800',
  closed: 'bg-surface-100 text-surface-800',
};

const defaultColors: Record<string, string> = {
  active: 'bg-green-100 text-green-800',
  online: 'bg-green-100 text-green-800',
  waiting: 'bg-yellow-100 text-yellow-800',
  pending: 'bg-yellow-100 text-yellow-800',
  ended: 'bg-surface-100 text-surface-800',
  closed: 'bg-surface-100 text-surface-800',
  resolved: 'bg-surface-100 text-surface-800',
  error: 'bg-red-100 text-red-800',
  urgent: 'bg-red-100 text-red-800',
  handed_over: 'bg-blue-100 text-blue-800',
  handover_requested: 'bg-orange-100 text-orange-800',
  agent_active: 'bg-purple-100 text-purple-800',
};

const FALLBACK = 'bg-surface-100 text-surface-800';

const colorMaps: Record<StatusVariant, Record<string, string>> = {
  session: sessionColors,
  handover: handoverColors,
  default: defaultColors,
};

function getStatusColor(status: string, variant: StatusVariant): string {
  const map = colorMaps[variant];
  return map[status] ?? FALLBACK;
}

export function StatusBadge({ status, variant = 'default', className = '' }: StatusBadgeProps) {
  const colorClass = getStatusColor(status, variant);
  const label = status.replace(/_/g, ' ');

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${colorClass} ${className}`}
    >
      {label}
    </span>
  );
}

export default StatusBadge;
